
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    navigate('/login');
  };

  return (
    <nav className="fixed top-0 w-full bg-white shadow-lg z-50" dir="rtl">
      <div className="px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 space-x-reverse">
            <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
              <i className="ri-exchange-dollar-line text-white text-lg"></i>
            </div>
            <div>
              <h1 className="text-lg font-bold text-gray-800">نظام التحويلات</h1>
              <p className="text-xs text-gray-600">مرحباً بك</p>
            </div>
          </div>

          <div className="relative">
            <button
              onClick={() => setShowMenu(!showMenu)}
              className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
            >
              <i className="ri-menu-line text-gray-600"></i>
            </button>

            {showMenu && (
              <div className="absolute left-0 top-12 bg-white rounded-lg shadow-xl border w-48 py-2">
                <button
                  onClick={() => navigate('/profile')}
                  className="w-full px-4 py-2 text-right hover:bg-gray-50 flex items-center justify-end space-x-2 space-x-reverse"
                >
                  <span>الملف الشخصي</span>
                  <i className="ri-user-line text-gray-600"></i>
                </button>
                <button
                  onClick={() => navigate('/settings')}
                  className="w-full px-4 py-2 text-right hover:bg-gray-50 flex items-center justify-end space-x-2 space-x-reverse"
                >
                  <span>الإعدادات</span>
                  <i className="ri-settings-line text-gray-600"></i>
                </button>
                <hr className="my-2" />
                <button
                  onClick={handleLogout}
                  className="w-full px-4 py-2 text-right hover:bg-gray-50 flex items-center justify-end space-x-2 space-x-reverse text-red-600"
                >
                  <span>تسجيل الخروج</span>
                  <i className="ri-logout-box-line"></i>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
